import React, { useState, useRef } from 'react';
import { useInView } from 'motion/react';

const LazyImage = ({ src, alt, className = '', fallback = 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&q=60' }) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "200px" });

  const imgSrc = error ? fallback : (src || fallback);

  return (
    <div ref={ref} className={`relative overflow-hidden ${className}`}>
      {/* Blur placeholder */}
      {!loaded && (
        <div className="absolute inset-0 bg-gradient-to-br from-[#FF6B35]/10 to-[#FFB627]/10 animate-pulse" />
      )}
      {isInView && (
        <img
          src={imgSrc}
          alt={alt}
          loading="lazy"
          decoding="async"
          onLoad={() => setLoaded(true)}
          onError={() => setError(true)}
          className={`w-full h-full object-cover transition-opacity duration-500 ${loaded ? 'opacity-100' : 'opacity-0'}`}
        />
      )}
    </div>
  );
};

export default LazyImage;
